import { Picklist } from "../../services/picklist/interfaces/picklist.interface";

/**
 * 選択値リストの配列を各種類ごとに展開します。
 * @param picklist
 */
export function expandPicklist(picklist: Picklist[]) {
  return {
    genderTypes: picklist?.find(p => p.name === "gender")?.values ?? [],
    howToKnowTypes: picklist?.find(p => p.name === "howToKnow")?.values ?? [],
    desiredJobTypes: picklist?.find(p => p.name === "desiredJobType")?.values ?? [],
  }
}